module.exports = __webpack_public_path__ + "static/media/krishnan.decde28d.jpg";